import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import DeprecatedSelect from "../../src/View/UI/DeprecatedSelect/DeprecatedSelect";
const RiskLevelLookup = (props) => {
    const options = [
        { value: 3, label: "Low" },
        { value: 2, label: "Medium" },
        { value: 1, label: "High" },
    ];
    return (_jsx(DeprecatedSelect, { "aria-label": "Risk Level", options: options, name: "form-field-name", onChange: (selectedOptions) => props.onChange(selectedOptions), value: props.selectedValues, multi: true }));
};
export default RiskLevelLookup;
